import "./locationAccountPreferencesDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationAccountPreferencesDetailsViewComponent
    from "./location-account-preferences-details-view/LocationAccountPreferencesDetailsViewComponent";
import LocationAccountPreferencesDetailsEditComponent
    from "./location-account-preferences-details-edit/locationAccountPreferencesDetailsEditComponent";

interface LocationAccountPreferencesDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateAccountPreferencesDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const LocationAccountPreferencesDetailsViewEditComponent = (props: LocationAccountPreferencesDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdateAccountPreferencesDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationAccountPreferences, setLocationAccountPreferences] = useState<any>(undefined);

    const handleAccountPreferencesUpdate = useCallback((updatedAccountPreferences: any) => {
        onUpdateAccountPreferencesDetails(updatedAccountPreferences);
        setMode("view");
    }, [onUpdateAccountPreferencesDetails]);

    const handleAccountPreferencesEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails?.accountPreferences) {
            setLocationAccountPreferences(locationDetails?.accountPreferences);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode);
    },[mode,onModeChange])

    return (
        <div className={'account-preferences-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationAccountPreferencesDetailsViewComponent
                    locationAccountPreferences={locationAccountPreferences}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <LocationAccountPreferencesDetailsEditComponent
                    locationAccountPreferences={locationAccountPreferences}
                    locationId={locationDetails.id}
                    onUpdateComplete={handleAccountPreferencesUpdate}
                    onEditCancel={handleAccountPreferencesEditCancel}
                />
            }
        </div>
    );

};

export default LocationAccountPreferencesDetailsViewEditComponent;